export default __webpack_public_path__ + "static/media/profile-pic.f3aff0f1.jpeg";